module.exports = __webpack_public_path__ + "static/img/yikang.4b4275b8.png";